import { ActionTypes } from "../contants/action-type";

const initialState = {
    restaurants: [],
    restaurant: {}
}

export const RestaurantReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_RESTAURANT:
            return {...state, restaurants: payload};
        case ActionTypes.SELECTED_RESTAURANT:
            return {...state, restaurant: payload};
        case ActionTypes.CONFIRM_CREATE_RESTAURANT:
            return {...state, restaurant: payload};
        case ActionTypes.CONFIRM_DELETE_RESTAURANT:
            return {...state, restaurants: payload};
        default:
            return state;
    }
}